var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon18(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 6.75H12.75C13.9907 6.75 15 7.75928 15 9V9.43945L14.7803 9.21973C14.4873 8.92676 14.0127 8.92676 13.7197 9.21973C13.4268 9.5127 13.4268 9.9873 13.7197 10.2803L15.2197 11.7803C15.3662 11.9268 15.5581 12 15.75 12C15.9419 12 16.1338 11.9268 16.2803 11.7803L17.7803 10.2803C18.0732 9.9873 18.0732 9.5127 17.7803 9.21973C17.4873 8.92676 17.0127 8.92676 16.7197 9.21973L16.5 9.43945V9C16.5 6.93237 14.8176 5.25 12.75 5.25H10.5C10.0858 5.25 9.75 5.58582 9.75 6C9.75 6.41418 10.0858 6.75 10.5 6.75Z",
    fill: "#C32A7C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 17.25C19.9926 17.25 21 16.2426 21 15C21 13.7574 19.9926 12.75 18.75 12.75C17.5074 12.75 16.5 13.7574 16.5 15C16.5 16.2426 17.5074 17.25 18.75 17.25Z",
    fill: "#C32A7C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 17.25H18.75H17.25C15.9042 17.25 15 18.4493 15 20.2343V21.75C15 22.1642 15.3358 22.5 15.75 22.5H21.75C22.1642 22.5 22.5 22.1642 22.5 21.75V20.2343C22.5 18.4493 21.5958 17.25 20.25 17.25Z",
    fill: "#C32A7C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 6C6.49264 6 7.5 4.99264 7.5 3.75C7.5 2.50736 6.49264 1.5 5.25 1.5C4.00736 1.5 3 2.50736 3 3.75C3 4.99264 4.00736 6 5.25 6Z",
    fill: "#C32A7C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9 10.5V8.98425C9 7.19934 8.09583 6 6.75 6H5.25H3.75C2.40417 6 1.5 7.19934 1.5 8.98425V10.5C1.5 10.9142 1.83582 11.25 2.25 11.25H8.25C8.66418 11.25 9 10.9142 9 10.5Z",
    fill: "#C32A7C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 17.25H11.25C10.0093 17.25 9 16.2407 9 15V14.5605L9.21973 14.7803C9.36621 14.9268 9.55811 15 9.75 15C9.94189 15 10.1338 14.9268 10.2803 14.7803C10.5732 14.4873 10.5732 14.0127 10.2803 13.7197L8.78027 12.2197C8.4873 11.9268 8.0127 11.9268 7.71973 12.2197L6.21973 13.7197C5.92676 14.0127 5.92676 14.4873 6.21973 14.7803C6.5127 15.0732 6.9873 15.0732 7.28027 14.7803L7.5 14.5605V15C7.5 17.0676 9.18237 18.75 11.25 18.75H13.5C13.9142 18.75 14.25 18.4142 14.25 18C14.25 17.5858 13.9142 17.25 13.5 17.25Z",
    fill: "#C32A7C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon18);
export default __webpack_public_path__ + "static/media/icon18.f24ac1099fa2016041cad5ee76f2b0de.svg";
export { ForwardRef as ReactComponent };